import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from "aws-amplify";
import * as pdfjs from 'pdfjs-dist/build/pdf';
import ReactGA from 'react-ga4';
import amplifyconfig from "./amplifyconfiguration.json";

ReactGA.initialize("G-HVNKW53TR8");

const currentEnv = window.location.hostname;
const signInRedirects = amplifyconfig.oauth.redirectSignIn.split(',');
const signInredirectURL = signInRedirects.find(r => r.includes(currentEnv))
const signOutRedirects = amplifyconfig.oauth.redirectSignOut.split(',');
const signOutRedirectURL = signOutRedirects.find(r => r.includes(currentEnv))

const awsExports = {
  ...amplifyconfig,
  oauth: {
    ...amplifyconfig.oauth,
    domain: process.env.REACT_APP_AMPLIFY_OAUTH_DOMAIN,
    redirectSignIn: signInredirectURL,
    redirectSignOut: signOutRedirectURL,
  }
}

Amplify.configure(awsExports);

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
window.pdfjsLib = pdfjs;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
